import {useContext, useState} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {SalesRepTypeReportContext} from '../../context'
// import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import moment from 'moment'
import Import from '../../../../images/Import.png'
import {MIN_DATE_RANGE, dataToSalesRepTypeReportCSV} from '../../utils'

const CustomerRepTypeReportHeader = () => {
  const {
    salesRepTypeData,
    handleSalesRepTypeReportDateChange,
    // salesRepTypes,
    // isSalesRepDropdownLoading,
    // onChangeSalesRepTypeFilter,
  } = useContext(SalesRepTypeReportContext)
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')

  const [isLoading, setIsLoading] = useState(false)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToSalesRepTypeReportCSV(salesRepTypeData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Sales_Rep_Type_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex flex-wrap justify-content-end align-items-center mb-10'>
      {/* <MultiSelect
        id={`sales-rep-filter`}
        label='Sales Rep Type'
        options={salesRepTypes}
        className='w-200px d-none'
        placeholder='Select Sales Rep Type'
        allValuesSelectedText={'Sales Rep Type: All'}
        isLoading={isSalesRepDropdownLoading}
        handleSelected={onChangeSalesRepTypeFilter}
      /> */}

      <div className='d-flex align-items-end gap-5'>
        <button
          className='btn btn-outline'
          onClick={handleDownLoadCSV}
          disabled={isLoading || !salesRepTypeData?.length}
        >
          <div className='d-flex align-items-center'>
            <img src={Import} alt='Import File' className='me-2 import-icon' />
            <div className='d-flex align-items-center'>
              {isLoading ? 'Downloading...' : 'Export CSV'}
              {isLoading && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </div>
          </div>
        </button>
        <PredefinedDateRange
          cb={handleSalesRepTypeReportDateChange}
          defaultValue={dateRangeLabel || 'Last 90 Days'}
          includeCurrantDay={true}
          startDate={MIN_DATE_RANGE}
        />
      </div>
    </div>
  )
}
export {CustomerRepTypeReportHeader}
